import { Programs } from "../../utils/compliance_program";

// Programs that support risk rating display
const RISK_RATING_PROGRAMS = new Set([
  Programs.US_AML,
  Programs.LUXEMBOURG_AML,
  Programs.CAYMANS_AML,
]);

/**
 * Checks if risk rating should be displayed for the given program.
 */
export const shouldShowRiskRating = (programId?: number): boolean => {
  return !!programId && RISK_RATING_PROGRAMS.has(programId);
};
